import CollectionCardMenu from "./collection-card-menu";

export default CollectionCardMenu;